module.exports = __webpack_public_path__ + "img/marktplaats.dbc45936.svg";